import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import OTPInput from "@Components/OtpInput/OtpInput";
import AuthCard from "@Components/AuthCard";
import useOtpContainer from "./useOtpContainer";

const OtpVerification = () => {
  const {
    navigate,
    otp,
    email,
    setOTP,
    form,
    handleSubmit,
    isVerifyingUser,
    canResend,
    timeLeftFormatted,
    handleResendOtp,
  } = useOtpContainer();

  const otpLength = 4;
  const isOtpComplete = otp.join("").length === otpLength;
  console.log(otp, "otp in otp verification page");

  return (
    <div className="flex justify-center items-center w-full">
      <AuthCard
        title="Enter Verification Code"
        description="Enter the 4 digit OTP you received on your email"
      >
        <h2 className="!text-[1rem] !font-medium sm:text-sm !text-[#1F3D2B] text-center !mt-0 mb-2 !pt-0 text-center">
          {email || '-'}
        </h2>
        <div className="py-2 sm:py-3">
         <Form form={form} initialValues={{ otp: otp }} layout="vertical">
            {/* OTP Input Field */}
            <Form.Item className="flex justify-center mb-8">
              <OTPInput length={otpLength} otp={otp} setOTP={setOTP} />
            </Form.Item>

            {/* Resend OTP Section */}
            <div className="flex flex-col items-center gap-3 mb-8 text-center">
              <p className="!text-base !font-medium text-secondaryGray">
                Didn't receive the code?{" "}
                <button
                  type="button"
                  className={`text-sm font-semibold underline transition-all ${
                    canResend
                      ? "text-secondaryGreen hover:text-secondaryGreen cursor-pointer"
                      : "text-!secondaryGreen cursor-not-allowed"
                  }`}
                  onClick={handleResendOtp}
                  disabled={!canResend}
                >
                  <span style={{ color: "#578C6C" }}>({timeLeftFormatted})</span>
                </button>
              </p>
            </div>

            {/* Verify Button */}
            <Form.Item className="text-center mb-4 sm:mb-6">
              <CustomButton
                title={"Verify Code"}
                shape="round"
                type="primary"
                className={`w-full !bg-primaryGreen h-11 sm:h-12 font-semibold tracking-wider rounded-[12px] !text-white !opacity-100 disabled:!bg-primaryGreen disabled:!text-white disabled:!border-none disabled:!opacity-100 ${
                  isOtpComplete ? "!cursor-pointer" : "!cursor-not-allowed"
                }`}
                 htmlType="button"
                isLoading={isVerifyingUser}
                disabled={isVerifyingUser}
                onClick={handleSubmit}
              />
            </Form.Item>

            {/* Back to Login Link */}
            <div className="text-center mb-4">
              <p className="text-sm font-medium !text-titleText">
                Back to{" "}
                <span
                  className="font-semibold !text-titleText cursor-pointer hover:!text-primaryGreen hover:underline transition-all"
                  onClick={() => navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)}
                >
                  login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </AuthCard>
    </div>
  );
};

export default OtpVerification;
